import { MutableRefObject, useRef } from 'react';
import useKeepScrolledToBottom from '../../utils/dom/useKeepScrolledToBottom';
import useIsOverflowingObserver from '../../utils/dom/useIsOverflowingObserver';

type UseCommentThreadHooksProps = {
    isDragging?: boolean;
};

export const useCommentThreadHooks = ({ isDragging }: UseCommentThreadHooksProps = {}) => {
    const contentContainerRef = useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;
    const contentRef = useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;

    useKeepScrolledToBottom(contentContainerRef, contentRef, isDragging);
    const isOverflowing = useIsOverflowingObserver(contentContainerRef, contentRef);

    return {
        contentContainerRef,
        contentRef,
        isOverflowing,
    };
};
